import React from 'react';

import AppRoutes from '../src/routes/routes';

import './App.css';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
